<template>
    <CommandItem :value="value" class="group">
        <span class="border border-gray-400 rounded-sm px-1 mr-2 group-data-[state=checked]:bg-primary">
            <i class="fass fa-check invisible text-white group-data-[state=checked]:visible"></i>
        </span>
        <span><slot /></span>
    </CommandItem>
</template>
<script setup lang="ts">
defineProps<{ value: string }>();
</script>
